import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrganizerSettings } from "../../app/features/organizer/organizerSettingsSlice";
import { BeatLoader } from "react-spinners";
import PastEvents from "./PastEvents";
import Gallery from "./Gallery";
import OrganizerUpcoming from "./OrganizerUpcoming";
import LogoMark from "../../gallery/default/logomark.png";

function OrganizerPage(props) {
  const location = useLocation();
  const dispatch = useDispatch();

  const substrings = location.pathname.split("/");
  const slug = substrings[2];

  const { data: settings, loading, error, status } = useSelector(
    (state) => state.organizerSettings
  );

  useEffect(() => {
    if (slug) {
      dispatch(fetchOrganizerSettings(slug));
    }
  }, [dispatch, slug]);

  return (
    <>
      <Helmet>
        <title>{`Sahi Search - ${settings.company_name}`}</title>
        <meta name="description" content="" />
      </Helmet>

      {loading && (
        <div className="loader-in-component-body">
          <BeatLoader color="#C6153B" />
        </div>
      )}

      {!loading && (status === 404 || status === 500 || error) && (
        <div className="text-center my-10">
          <div className="mb-4">
            <img
              src={LogoMark}
              alt="Error"
              className="img-fluid mx-auto"
              style={{ maxWidth: "200px" }}
            />
          </div>
          <h2 className="text-danger mb-3">Organizer Not Found</h2>
          <p className="text-muted mb-4">
            {error || "We couldn’t find this organizer. Please try again."}
          </p>
          <Link to="/" className="btn btn-primary">
            Go Back
          </Link>
        </div>
      )}

      {!loading && settings && (
        <>
          <div className="banner-container">
            {settings.banner_type === 1 && settings.banner_url && (
              <img
                src={settings.banner_url}
                alt="Organizer Banner"
                className="banner-image img-fluid shadow-lg"
              />
            )}

            {settings.banner_type === 2 && settings.video_url && (
              <div className="video-banner-wrapper">
                <div className="video-banner-overlay" />
                <iframe
                  className="video-banner-iframe"
                  src={`https://www.youtube-nocookie.com/embed/${new URLSearchParams(
                    new URL(settings.video_url).search
                  ).get("v")}?autoplay=1&mute=1&controls=0&rel=0&modestbranding=1&loop=1&playlist=${new URLSearchParams(
                    new URL(settings.video_url).search
                  ).get("v")}&disablekb=1&iv_load_policy=3&fs=0&playsinline=1&showinfo=0&vq=hd1080`}
                  title="Organizer Video Banner"
                  allow="autoplay; encrypted-media"
                  allowFullScreen={false}
                ></iframe>
              </div>
            )}
          </div>

          {/* Other sections */}
          <OrganizerUpcoming slug={slug} />
          <Gallery slug={slug} />
          <PastEvents slug={slug} />

          {settings.company_name && (
            <div className="container mt-3">
              <h2 className="about-user">About {settings.company_name}</h2>
              <hr />
              <p className="mb-5 about-user-content">{settings.about}</p>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default OrganizerPage;
